import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-background",
  "use": "icon-background-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-background\"><defs><style>#icon-background .cls-1{fill:#fff;}</style></defs><path class=\"cls-1\" d=\"M12,16.24l2.17-2.6a.52.52,0,0,1,.85.07l3,5h2.84a.52.52,0,0,1,0,1H3.11a.52.52,0,0,1,0-1H4.32l3-8a.52.52,0,0,1,.43-.34.51.51,0,0,1,.49.23Z\" /><circle class=\"cls-1\" cx=\"17.73\" cy=\"8.77\" r=\"3.64\" /><path class=\"cls-1\" d=\"M22.45,3H.5V21.82h23V3Zm0,17.77H1.55V4H22.45Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol